<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
            :expandedOptions="{
                enabled: true,
                template: 'account-other-communication',
            }"
        ></dx-grid>
        <v-dialog persistent v-model="assignCallDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >{{
                        this.action == "assign" ? "Pickup" : "Unassign"
                    }}
                    Calls</v-card-title
                ><v-card-text class="py-0 pb-3 pl-0 font-weight-medium"
                    >The calls bellow will be
                    {{
                        (this.action == "assign"
                            ? "assigned to"
                            : "unassigned from ") +
                            " " +
                            user
                    }}</v-card-text
                >
                <div v-if="!getSelectedCallbacks().length" class="text-warning">
                    {{
                        this.action == "assign"
                            ? "Please select callback requests that are not assigned to anyone."
                            : "Please select callback requests that are assigned to you."
                    }}
                </div>
                <div v-else>
                    <v-layout row class="font-weight-medium">
                        <div style="width: 250px;">Name</div>
                        <div>Callback Number</div>
                    </v-layout>
                    <v-divider class="mt-2 pb-2"></v-divider>
                    <div v-for="(call, index) in getSelectedCallbacks()">
                        <v-layout row>
                            <div style="width: 250px;">{{ call.name }}</div>
                            <div>
                                {{ formatPhoneNumber(call.callbackNumber) }}
                            </div>
                        </v-layout>
                        <v-divider
                            class="mt-2 pb-2"
                            v-if="index + 1 < selectedCallbacks.length"
                            :key="index"
                        ></v-divider>
                    </div>
                    <div
                        v-if="associatedCallbacks.length"
                        class="my-3"
                        style="border: 1px solid black; padding: 10px; padding-bottom: 16px"
                    >
                        <div class="mb-2 font-weight-medium text-xs-center">
                            We have found other callback requests for the
                            selected accounts.
                        </div>
                        <v-checkbox
                            class="mt-2 mb-3"
                            hide-details
                            color="success"
                            label="Include Other Callback Requests"
                            v-model="includeAssociatedCallbacks"
                        ></v-checkbox>

                        <div
                            v-bind:class="{
                                'gray-fg': !includeAssociatedCallbacks,
                            }"
                        >
                            <v-layout row class="font-weight-medium">
                                <div style="width: 250px;">Name</div>
                                <div>Callback Number</div>
                            </v-layout>
                            <v-divider class="mt-2 pb-2"></v-divider>
                            <div v-for="(call, index) in associatedCallbacks">
                                <v-layout row>
                                    <div style="width: 250px;">
                                        {{ call.name }}
                                    </div>
                                    <div>
                                        {{
                                            formatPhoneNumber(
                                                call.callbackNumber,
                                            )
                                        }}
                                    </div>
                                </v-layout>
                                <v-divider
                                    class="mt-2 pb-2"
                                    v-if="
                                        index + 1 < associatedCallbacks.length
                                    "
                                    :key="index"
                                ></v-divider>
                            </div>
                        </div>
                    </div>
                </div>
                <v-layout
                    row
                    class="mt-3 px-3 py-2"
                    style="border: 2px solid #4caf50; border-radius: 10px;"
                    v-if="action != 'assign'"
                >
                    <div class="mr-3 pt-3 my-2">Assign To Someone Else?</div>

                    <v-autocomplete
                        class="my-2"
                        hide-details
                        label="Assigned To"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="assignToUser"
                        v-model="assignToUser"
                        :items="users"
                        :search-input.sync="loadUsers"
                    ></v-autocomplete>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="assignCallDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        :disabled="!getSelectedCallbacks().length"
                        @click="saveAssigned()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="unknownAccountDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Assign Account -
                    {{ unknownAccount.accountID }}</v-card-title
                >
                <div
                    class="pa-3"
                    style="border: 2px solid #4caf50; border-radius: 3px"
                >
                    <div class="subheading mb-2">
                        Select Account ID
                    </div>
                    <v-autocomplete
                        class="mb-3"
                        hide-details
                        label="Account ID"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="newAccountID"
                        v-model="newAccountID"
                        :items="accounts"
                        :search-input.sync="loadAccounts"
                    ></v-autocomplete>
                    <v-textarea
                        class="mt-2 mb-2"
                        hide-details
                        label="Note"
                        v-model="unknownAccount.note"
                        ref="note"
                        rows="4"
                        outline
                        font-weight-medium
                    ></v-textarea>
                    <v-checkbox
                        label="Save For Future"
                        color="success"
                        v-model="unknownAccount.saveForFuture"
                        hide-details
                    ></v-checkbox>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUnknownDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveUnknownAccount()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="markAsCompletedDialog" max-width="700">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Mark As Completed</v-card-title
                ><v-card-text class="py-0 pb-3 pl-0 font-weight-medium"
                    >The callback requests bellow will be marked as
                    completed</v-card-text
                >
                <div v-if="!selectedCallbacks.length" class="text-warning">
                    {{
                        "Please select callback requests that are assigned to you or unassigned."
                    }}
                </div>
                <div v-else>
                    <v-layout row class="font-weight-medium">
                        <div style="width: 250px;">Name</div>
                        <div style="width: 150px;">Callback Number</div>
                        <div>Note</div>
                    </v-layout>
                    <v-divider class="mt-2 pb-2"></v-divider>
                    <div v-for="(callback, index) in selectedCallbacks">
                        <v-layout row>
                            <div style="width: 250px;">{{ callback.name }}</div>
                            <div style="width: 150px;">
                                {{ formatPhoneNumber(callback.callbackNumber) }}
                            </div>
                            <v-text-field
                                class="ml-2 pt-0 mt-0"
                                hide-details
                                v-model="callback.note"
                                label="Note"
                            ></v-text-field>
                        </v-layout>
                        <v-divider
                            class="mt-2 pb-2"
                            v-if="index + 1 < selectedCallbacks.length"
                            :key="index"
                        ></v-divider>
                    </div>
                    <!-- <div
                        v-if="associatedCallbacks.length"
                        class="my-3"
                        style="border: 1px solid black; padding: 10px"
                    >
                        <div class="mb-2 font-weight-medium">
                            We have found other callback requests for the
                            selected accounts.
                        </div>
                        <v-checkbox
                            class="mt-2 mb-3"
                            hide-details
                            color="success"
                            label="Include Other Callback Requests"
                            v-model="includeAssociatedCallbacks"
                        ></v-checkbox>
                        <div
                            v-bind:class="{
                                'gray-fg': !includeAssociatedCallbacks,
                            }"
                        >
                            <v-layout row class="font-weight-medium">
                                <div style="width: 250px;">Name</div>
                                <div style="width: 150px;">Callback Number</div>
                                <div>Note</div>
                            </v-layout>
                            <v-divider class="mt-2 pb-2"></v-divider>
                            <div
                                v-for="(callback, index) in associatedCallbacks"
                            >
                                <v-layout row>
                                    <div style="width: 250px;">
                                        {{ callback.name }}
                                    </div>
                                    <div style="width: 150px;">
                                        {{
                                            formatPhoneNumber(
                                                callback.callbackNumber
                                            )
                                        }}
                                    </div>
                                    <v-text-field
                                        :disabled="!includeAssociatedCallbacks"
                                        class="ml-2 pt-0 mt-0"
                                        hide-details
                                        v-model="callback.note"
                                        label="Note"
                                    ></v-text-field>
                                </v-layout>
                                <v-divider
                                    class="mt-2 pb-2"
                                    v-if="index + 1 < associatedCallbacks.length"
                                    :key="index"
                                ></v-divider>
                            </div>
                        </div>
                    </div> -->
                    <v-textarea
                        class="mt-2 mb-2"
                        hide-details
                        label="Note"
                        v-model="markAsCompletedNote"
                        ref="note"
                        rows="4"
                        outline
                        font-weight-medium
                    ></v-textarea>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="markAsCompletedDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        :disabled="!selectedCallbacks.length"
                        @click="markAsCompleted()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";
import { formatPhoneNumber } from "../../utils/helpers.js";
import * as firebase from "firebase/app";
import "firebase/database";

export default {
    data: () => ({
        title: "Pending Callback Requests",
        columns: [
            {
                label: "Account ID",
                field: "accountID",
                template: "link-action-cell-template",
                format: "",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "dateTime",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(3, "day")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Communications Count (Last 30 Days)",
                field: "communicationCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Caller ID",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Callback Number",
                field: "callbackNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone Line",
                field: "phoneLine",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "play-audio-cell-template",
                field: "recording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                durationColumn: "recordingDuration",
            },
            {
                label: "AssignedTo",
                field: "assignedTo",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording Updated At",
                field: "recordingUpdatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registration Status",
                field: "registrationStatus",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Requirements",
                field: "missingRequirements",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Classes",
                field: "studentClasses",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Completed At",
            //     field: "completedAt",
            //     type: "date",
            //     format: "MM/dd/yyyy hh:mm:ss a",
            //     visible: true,
            //     sortOrder: "desc",
            //     sortIndex: 0,
            // },
        ],

        actions: [],

        markAsCompletedDialog: false,
        markAsCompletedNote: "",
        selectedCallbacks: [],
        associatedCallbacks: [],
        includeAssociatedCallbacks: false,
        url: "",
        assignCallDialog: false,
        user: "",
        processing: false,
        action: "",

        unknownAccountDialog: false,
        unknownAccount: "",
        newAccountID: "",
        accounts: [],
        loadAccounts: null,
        firebaseRef: "",

        users: [],
        loadUsers: null,
        assignToUser: "",
    }),
    mounted() {
        if (this.$refs && this.$refs.grid) {
            this.firebaseSetup();
        }
    },
    watch: {
        async loadAccounts(value) {
            if (!value) return;

            const response = await this.$http.get(
                "api/accounts/getAccountIDs?value=" + value,
            );

            this.accounts = response;
        },
        async loadUsers(value) {
            if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${value.trim()}'))`,
            );

            this.users = response.value.map((u) => u.userName);
        },
    },
    beforeDestroy() {
        this.firebaseRef.off();
    },
    created() {
        this.columns.find(
            (c) => c.field == "accountID",
        ).linkAction = this.onAccountIDClick;

        this.user = this.$store.state.authentication.user;
    },
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Pickup Calls",
                action: this.assignCall,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Unassign Calls",
                action: this.unassignCall,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Update Calls",
                action: this.openMarkAsCompletedDialog,
                showOnSelection: true,
            });

            this.columns.find(
                (c) => c.field == "accountID",
            ).linkAction = this.onAccountIDClick;

            this.url =
                "communications?type=CALLBACK REQUEST&status=PENDING&user=" +
                this.user;
        },
        onAccountIDClick(row) {
            this.onRowClicked(row);
        },
        async onRowClicked(row) {
            if (!row.accountID.startsWith("CallerID")) {
                this.$router.push({
                    name: "Account View",
                    params: {
                        id: row.accountID,
                    },
                    query: {
                        goToCallbackSection: true,
                    },
                });

                return;
            }

            this.unknownAccount = row;
            this.unknownAccount.saveForFuture = true;

            this.newAccountID = "";
            this.unknownAccountDialog = true;
        },
        closeUnknownDialog() {
            this.accounts = [];
            this.newAccountID = "";
            this.unknownAccount.note = "";
            this.unknownAccountDialog = false;
        },
        async saveUnknownAccount() {
            this.processing = true;

            try {
                await this.$http.post("api/broadcast/assignAccount?", {
                    fromAccount: this.unknownAccount.accountID,
                    accountID: this.newAccountID,
                    callerID: this.unknownAccount.callerID,
                    note: this.unknownAccount.note,
                    user: this.user,
                    communicationID: this.unknownAccount.id,
                    type: "CALLBACK REQUEST",
                    saveForFuture: this.unknownAccount.saveForFuture,
                });

                this.processing = false;
            } catch (e) {
                this.processing = false;

                return;
            }

            this.accounts = [];
            this.newAccountID = "";
            this.unknownAccountDialog = false;

            this.$refs.grid.reloadGrid();
        },
        async openMarkAsCompletedDialog() {
            this.associatedCallbacks = [];
            this.includeAssociatedCallbacks = false;
            const selectedCallbacks = this.$refs.grid.getSelectedRowsData();

            this.selectedCallbacks = selectedCallbacks.filter(
                (c) =>
                    c.assignedTo == "Unassigned" || c.assignedTo == this.user,
            );

            this.markAsCompletedDialog = true;
        },
        async markAsCompleted() {
            const callbacks = this.includeAssociatedCallbacks
                ? this.selectedCallbacks.concat(this.associatedCallbacks)
                : this.selectedCallbacks;

            if (!this.markAsCompletedNote) {
                if (callbacks.every((c) => !c.note)) {
                    this.$notify({
                        text:
                            "Can't mark as completed without entering a note. Please enter a note.",
                        group: "notification",
                        type: "error",
                    });

                    return;
                } else {
                    callbacks.forEach((callback) => {
                        if (!callback.note) {
                            this.$notify({
                                text:
                                    "Callback request of " +
                                    callback.name +
                                    " is missing a note. please enter a note.",
                                group: "notification",
                                type: "error",
                            });
                        }
                    });

                    if (callbacks.some((c) => !c.note)) {
                        return;
                    }
                }
            }

            this.processing = true;

            const data = callbacks.map((callback) => ({
                note: callback.note ? callback.note : this.markAsCompletedNote,
                status: "COMPLETED",
                communicationID: callback.id,
                callbackID: callback.callbackRequestID,
                user: this.user,
            }));

            try {
                await this.$http.post(
                    "api/Communications/UpdateCommunications",
                    data,
                );

                this.processing = false;
                this.markAsCompletedDialog = false;
                this.markAsCompletedNote = "";
            } catch (e) {
                this.processing = false;
            }
        },
        getSelectedCallbacks() {
            return this.action == "assign"
                ? this.selectedCallbacks.filter(
                      (c) => !c.assignedTo || c.assignedTo == "Unassigned",
                  )
                : this.selectedCallbacks.filter(
                      (c) => c.assignedTo == this.user,
                  );
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("navigation");

            const query = ref
                .orderByChild("Name")
                .equalTo("CallbackRequest")
                .limitToLast(1);

            this.firebaseRef = query;

            query.on(
                "value",
                (snapshot) => {
                    this.$refs.grid.reloadGrid();
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        async assignCall() {
            this.includeAssociatedCallbacks = false;
            this.selectedCallbacks = this.$refs.grid.getSelectedRowsData();

            if (this.selectedCallbacks.length) {
                const associatedCallbacks = await this.$http.post(
                    "api/communications/getOtherCalls?",
                    this.selectedCallbacks.map((s) => s.callbackRequestID),
                );

                this.associatedCallbacks = associatedCallbacks;
            }

            this.action = "assign";
            this.assignCallDialog = true;
        },
        async unassignCall() {
            this.selectedCallbacks = this.$refs.grid.getSelectedRowsData();

            this.action = "unassign";
            this.assignCallDialog = true;

            const response = await this.$http.get(`/odata/users?$count=true`);

            this.users = response.value.map((u) => u.userName);
        },
        async saveAssigned() {
            this.processing = true;

            const callbacks = this.includeAssociatedCallbacks
                ? this.selectedCallbacks.concat(this.associatedCallbacks)
                : this.selectedCallbacks;

            try {
                await this.$http.post("api/communications/assignCallback", {
                    user: this.user,
                    assignedToUser: this.assignToUser
                        ? this.assignToUser
                        : null,
                    assignAction: this.action,
                    callbackRequestIDs: callbacks.map(
                        (c) => c.callbackRequestID,
                    ),
                });

                this.processing = false;
                this.assignCallDialog = false;
                this.assignToUser = "";
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
